export default {
  "post|Notification/GetNotifications": (option) => {
    let list = [
      {
        readFlag: "0",
        updateDate: "2020-01-01 09:12:08",
        detailLink: "/notice/detail",
        newsTitle: "スポット人材紹介をローンチしました。",
      },
      {
        readFlag: "0",
        updateDate: "2020-01-01 09:12:08",
        detailLink: "/notice/detail",
        newsTitle: "利用規約が更新されました。",
      },
      {
        readFlag: "0",
        updateDate: "2020-01-01 09:12:08",
        detailLink: "/notice/detail",
        newsTitle:
          "伊林さんによりビジネスマッチングの自法人情報が更新されました。",
      },
      {
        readFlag: "1",
        updateDate: "2020-01-01 09:12:08",
        category: 4,
        detailLink: "/notice/detail",
        newsTitle: "候補者リストを受領しました。",
      },
      {
        readFlag: "1",
        updateDate: "2020-01-01 09:12:08",
        detailLink: "/notice/detail",
        newsTitle: "業界平均値を更新しました。",
      },
      {
        readFlag: "1",
        updateDate: "2020-01-01 09:12:08",
        detailLink: "/notice/detail",
        newsTitle: "スポット人材紹介をローンチしました。",
      },
      {
        readFlag: "1",
        updateDate: "2020-01-01 09:12:08",
        detailLink: "/notice/detail",
        newsTitle: "利用規約が更新されました。",
      },
      {
        readFlag: "1",
        updateDate: "2020-01-01 09:12:08",
        detailLink: "/notice/detail",
        newsTitle:
          "伊林さんによりビジネスマッチングの自法人情報が更新されました。",
      },
      {
        readFlag: "1",
        updateDate: "2020-01-01 09:12:08",
        detailLink: "/notice/detail",
        newsTitle: "候補者リストを受領しました。",
      },
      {
        readFlag: "1",
        updateDate: "2020-01-01 09:12:08",
        detailLink: "/notice/detail",
        newsTitle: "業界平均値を更新しました。",
      },
    ];
    return {
      code: 200,
      msg: "操作成功",
      data: {
        totalCount: list.length * 5,
        list,
      },
    };
  },
  "post|Notification/ReadNotification": (option) => {
    return {
      code: 200,
      msg: "操作成功",
      data: {},
    };
  },
};
